$(function(){
    loginPage.init()

  $('#customer_login input[type="submit"]').click(function(){
    loginPage.watchSignInBtn()
  })

  // 触发提示的显示/隐藏
  $('#CustomerEmail,#CustomerPassword,input[type="text"],input[type="email"],input[type="password"]').bind('input porpertychange',function(){
    if ($(this).val()!='') {
      $(this).siblings('.error-msg-bottom,.input-error-message,.form-message').hide()
    }else{
      $(this).siblings('.error-msg-bottom,.input-error-message').show()
    }
  })

  // 触发显示label
  $('#CustomerEmail,#CustomerPassword,input[type="text"],input[type="email"],input[type="password"]').focus(function(){
    $(this).siblings('label').addClass('labelShow')
  })
  $('#CustomerEmail,#CustomerPassword,input[type="text"],input[type="email"],input[type="password"]').blur(function(){
    if ($(this).val()=='') {
      $(this).siblings('label').removeClass('labelShow')
    }
  })

  // 显示/隐藏密码框信息
  $('.pswEye').click(function(){
    $(this).toggleClass('show')
    if ($(this).siblings('input').attr('type')=='text') {
      $(this).siblings('input').attr('type','password')
    }else{
      $(this).siblings('input').attr('type','text')
    }
  })

  // 注册
  $('.show_register_form_box,.create_btn').click(function(){
    $('.register_form_box,.divCreateForm').show()
    $('.register_form_tips,.divLoginForm').hide()
  })
  $('.backToLogin').click(function(){
    if (window.innerWidth<=768) {
      $('.divLoginForm').show()
      $('.divCreateForm').hide()
    }else{
      console.log('aaa');
      $('.register_form_box').hide()
      $('.register_form_tips,.divLoginForm').show()
    }
  })

  // 显示密码框眼睛
  $('#CustomerPassword,#RegisterForm-password,#Confirm-password,#ResetPassword,#PasswordConfirmation').bind('input porpertychange',function(){
    if ($(this).val().length>0) {
      $(this).siblings('.pswEye').addClass('active')
    }else{
      $(this).siblings('.pswEye').removeClass('active show')
      $(this).attr('type','password')
    }
  })

  // 检查form表单填写的信息是否符合规格,符合的话点击时触发真实的提交按钮
  $('.checkFormMsgBtn').click(function(){
    loginPage.checkRegisterForm()
  })

  // 检查重置密码的form表单填写的信息是否符合规格,符合的话点击时触发真实的提交按钮
  $('.resetPswFakeBtn').click(function(){
    loginPage.checkResetPswForm()
  })

  $('#RecoverPassword').click(function(){
    $('.divCreateForm').hide()
  })
  $('#HideRecoverPasswordLink,.resetBackToLogin').click(function(){
    $('#RecoverPasswordForm').addClass('hide')

    if (window.innerWidth<=768) {
      $('#CustomerLoginForm').removeClass('hide')
    }else{
      $('.divCreateForm').removeClass('hide').show()
      $('#CustomerLoginForm').removeClass('hide')
      history.pushState('', '', window.location.href.replace('#recover','')); 
    }
  })

  $('.checkSignInBtn').click(function(){
    loginPage.checkLoginForm()
  })

  $('.checkResetPwBtn').click(function(){
    $('.input-error-message').remove()
    let _val = $('#RecoverEmail').val()
    if (_val=='') {
      $('#RecoverEmail').after(`<span class="input-error-message"><span>Email can't be blank.</span></span>`)
      return false
    }
    if (!loginPage.checkEmailFormat(_val)) {
      $('#RecoverEmail').after(`<span class="input-error-message"><span>Email is invalid.</span></span>`)
      return false
    }
    $(this).addClass('loading')
    $(this).siblings('input[type="submit"]').trigger('click')
  })

})


let loginPage = {
  formValue: JSON.parse(sessionStorage.getItem('signInForm')),
  formRegisterValue: JSON.parse(sessionStorage.getItem('registerForm')),
  init(){
    // 删除 registerWIthNewsletter
    localStorage.removeItem('registerWIthNewsletter')

    if (window.location.href.indexOf('/account/login')!=-1) {
      let hasErrorMessage = $('.form-message--error').length > 0;
      if (hasErrorMessage) {
        $('.form-message--error').hide()
          // 登录
        console.log('登录');
        sessionStorage.removeItem('signInForm')
        this.handleErrorMessage()
      }
    }else if (window.location.href.indexOf('/account/register')!=-1){
      $('.divCreateForm').show()
      let hasErrorMessage = $('.form-message--error').length > 0;
      if (hasErrorMessage) {
        $('.form-message--error').hide()
      }
      // 注册
      console.log('注册');
      sessionStorage.removeItem('registerForm')
      if (this.formRegisterValue) {
        $('#RegisterForm-email').val(this.formRegisterValue.email).siblings('label').addClass('labelShow')
        $('#RegisterForm-password').val(this.formRegisterValue.psword).siblings('.pswEye').addClass('active').siblings('label').addClass('labelShow')
      }else{
        $('#RegisterForm-email').siblings('label').addClass('labelShow')
        $('#RegisterForm-password').siblings('.pswEye').addClass('active').siblings('label').addClass('labelShow')
      }
    }

    // 链接带了recover，为忘记密码页面，需隐藏右边注册模块
    console.log(window.location.href);
    if (window.location.href.indexOf('login#recover')!=-1) {
      $('#CustomerLoginForm').addClass('hide')
      $('#RecoverPasswordForm').removeClass('hide')
      $('.divCreateForm').hide()
    }

  },
  watchSignInBtn(){
    sessionStorage.setItem('signInForm',JSON.stringify({
      email: $('#CustomerEmail').val(),
      psword: $('#CustomerPassword').val()
    }))
  },
  handleErrorMessage(){
    $('#CustomerEmail').val(this.formValue.email).siblings('label').addClass('labelShow')
    $('#CustomerPassword').val(this.formValue.psword).siblings('.pswEye').addClass('active').siblings('label').addClass('labelShow')

    if (this.formValue.email =='') {
      $('#CustomerEmail').parent('.form-row').append("<span class='error-msg-bottom'>Email can't be blank</span>")
    }
    if (this.formValue.psword =='') {
      $('#CustomerPassword').parent('.form-row').append("<span class='error-msg-bottom'>Password can't be blank</span>")
    }
    if (this.formValue.email !='' && this.formValue.psword !='') {
      let _len = $('.form-message--error .errors').find('li').length
      let _errStr = '<div class="errMsgInHeader">'
      for (let i = 0; i < _len; i++) {
        let item = $('.form-message--error .errors').find('li').eq(i).html();
        if (item.indexOf('Incorrect email or password')!=-1) {
          item = 'Please check you have entered your email and password correctly.'
        }
        _errStr = _errStr +'<span>'+item+'</span>'
      }
      _errStr = _errStr + '</div>'
      $('#CustomerLoginForm h2').append(_errStr)
    }
  },
  // 若勾选了同意订阅的选项，则在注册成功，页面刷新后再执行订阅操作
  checkRegisterForm(){
    let isPass = true
    $('.input-error-message').remove()
    if ($('#RegisterForm-email').val()=='') {
      $('#RegisterForm-email').after(`<span class="input-error-message"><span>Email can't be blank.</span></span>`)
      isPass = false
    }else{
      if (!loginPage.checkEmailFormat($('#RegisterForm-email').val())) {
        $('#RegisterForm-email').after(`<span class="input-error-message"><span>Email is invalid.</span></span>`)
        isPass = false
      }
    }
    if ($('#RegisterForm-password').val()=='') {
      $('#RegisterForm-password').after(`<span class="input-error-message"><span>Password can't be blank.</span></span>`)
      isPass = false
    }else{
      if($('#RegisterForm-password').val().length<5){
        $('#RegisterForm-password').after(`<span class="input-error-message"><span>Password is too short (minimum is 5 characters).</span></span>`)
        isPass = false
      }
    }
    
    if ($('#Confirm-password').val()=='') {
      $('#Confirm-password').after(`<span class="input-error-message"><span>Please confirm your password.</span></span>`)
      isPass = false
    }else {
      if ($('#Confirm-password').val() != $('#RegisterForm-password').val()) {
        $('#Confirm-password').after(`<span class="input-error-message"><span>Does not match password.</span></span>`)
        isPass = false
      } 
    }
    
    if(!$('#registerPrivacy').prop("checked")){
      $('label[for="registerPrivacy"]').after(`<span class="input-error-message" style="width:100%;text-align: left;"><span>Please accept the privacy policy.</span></span>`)
      isPass = false
    }

    if (isPass) {
      $('.checkFormMsgBtn').addClass('loading')
      // 缓存注册时填写的邮箱和密码
      sessionStorage.setItem('registerForm',JSON.stringify({
        email: $('#RegisterForm-email').val(),
        psword: $('#RegisterForm-password').val()
      }))
      // 点击注册时,存储是否勾选了订阅按钮.当页面刷新后还是停留此页面时,表示注册未成功，
      // 当页面刷新后回到首页，则表示注册成功，需根据 registerWIthNewsletter 判断是否需要进行订阅操作
      localStorage.setItem('registerWIthNewsletter', $('#registerSubscribe').prop("checked"))
      console.log('是否勾选了订阅:'+localStorage.getItem('registerWIthNewsletter'));
      $('.submitFormBtn').trigger('click')
    }
    
  },
  // 验证重置密码框
  checkResetPswForm(){
    let isPass = true
    $('.input-error-message').remove()
    if ($('#ResetPassword').val()=='') {
      $('#ResetPassword').after(`<span class="input-error-message"><span>Password can't be blank.</span></span>`)
      isPass = false
    }
    if ($('#PasswordConfirmation').val()=='') {
      $('#PasswordConfirmation').after(`<span class="input-error-message"><span>Please confirm your password.</span></span>`)
      isPass = false
    }else{
      if ($('#PasswordConfirmation').val() != $('#ResetPassword').val()) {
        $('#PasswordConfirmation').after(`<span class="input-error-message"><span>Does not match password.</span></span>`)
        isPass = false
      } 
    }
    if(isPass){
      $('.resetPswFakeBtn').addClass('loading')
      $('.resetPswBtn').trigger('click')
    }
  },
  // 验证登录框
  checkLoginForm(){
    let isPass = true
    $('.input-error-message,.errMsgInHeader').remove()
    if($('#CustomerEmail').val()==''){
      $('#CustomerEmail').after(`<span class="input-error-message"><span>Email can't be blank.</span></span>`)
      isPass = false
    }
    if($('#CustomerPassword').val()==''){
      $('#CustomerPassword').after(`<span class="input-error-message"><span>Email can't be blank.</span></span>`)
      isPass = false
    }
    if (isPass) {
      $('.checkSignInBtn').addClass('loading')
      $('.checkSignInBtn').siblings('.signInBtn').trigger('click')
    }
  },
  // 检查邮箱格式：@符号前后是否有字符
  checkEmailFormat(val){
    let e_split_arr = val.split('@')
    if (e_split_arr.length>=2) {
      if (e_split_arr[0]==''||e_split_arr[1]=='') {
        return false
      }
    }else{
      return false
    }

    return true
  }
}